/**
 * VoiceMailContent.js
 * 
 * Created on Oct 23, 2013, 16:05:02
 *
 * @author Olivier van der Pool for Ranj
 **/

import { isNull, isUndefined } from "../../util/TypeUtil";
import Content from "./Content";
import ENGLanguagePackContentType from "./ENGLanguagePackContentType";

export default class VoiceMailContent extends Content {
    constructor(languagePack, contentID, sender, audio, dateTimeOffset, label) {
        isUndefined(contentID) ? contentID = null : null;
        isUndefined(sender) ? sender = null : null;
        isUndefined(audio) ? audio = null : null;
        isUndefined(dateTimeOffset) ? dateTimeOffset = 0 : null;
        isUndefined(label) ? label = null : null;

        super(VoiceMailContent.NAME, VoiceMailContent.TYPE, label, languagePack, contentID);

        this._dateTimeOffset = dateTimeOffset;
        this._date = null;
        this.opened = false;
        this._sender = sender;
        this._audio = audio;
    }

    getAudio() {
        return this.getLanguagePackContent(VoiceMailContent.AUDIO_LABEL, ENGLanguagePackContentType.AUDIO);
    }

    setAudio(value) {
        if (this._audio !== value) {
            this.setLanguagePackContent(VoiceMailContent.AUDIO_LABEL, ENGLanguagePackContentType.AUDIO, value);
        }
    }

    getSender() {
        return this.getLanguagePackText(VoiceMailContent.SENDER_LABEL);
    }

    setSender(value) {
        if (this._sender !== value) {
            this.setLanguagePackText(VoiceMailContent.SENDER_LABEL, value);
        }
    }

    getDate() {
        return this._date;
    }

    setDate(value) {
        if (this._date !== value) {
            this._date = value;
        }
    }

    setDateTimeOffset(currentDate) {
        if (isUndefined(currentDate)) {
            currentDate = new Date();
        }
        this._date = new Date();
        this._date.time = currentDate.time + this.dateTimeOffset;
    }

    getDateTimeOffset() {
        return this.dateTimeOffset;
    }

    setOpened(value) {
        this._opened = value;
    }

    getOpened() {
        return this._opened;
    }

    setPropertiesFromObject(object) {
        if (object.date) {
            this._date = new Date(object.date);
            delete object.date;
        }
        super.setPropertiesFromObject(object);
    }

    convertToObject() {
        const object = this.getObject(["opened", "dateTimeOffset"]);
        if (!isNull(this._date)) {
            object.date = this._date.valueOf();
        }
        return object;
    }
}

VoiceMailContent.NAME = "Voicemail";
VoiceMailContent.TYPE = "engVoiceMailContent";
VoiceMailContent.SENDER_LABEL = "sender";
VoiceMailContent.AUDIO_LABEL = "audio";